import { render, staticRenderFns } from "./TolSimpleTable.vue?vue&type=template&id=4bbdc458&scoped=true&"
import script from "./TolSimpleTable.vue?vue&type=script&lang=js&"
export * from "./TolSimpleTable.vue?vue&type=script&lang=js&"
import style0 from "./TolSimpleTable.vue?vue&type=style&index=0&id=4bbdc458&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbdc458",
  null
  
)

export default component.exports